import React from 'react';

import styles from './HelpIcon.module.scss';

const HelpIcon: React.FC = () => {
  return <span className={styles.helpIcon} /> /* ii */;
};

export default HelpIcon;
